import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import getStorageData from "../../../Utils/getStorageData";

const PremiseDropdown = () => {
  const { allPremise, selectedPremiseID } = getStorageData();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentPremise, setCurrentPremise] = useState(selectedPremiseID);

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const handlePremiseChange = (premiseId) => {
    setCurrentPremise(premiseId);
    localStorage.setItem("selectedPremiseID", premiseId);
    window.location.reload(); // reload to rebuild routes and sidebar
  };

  if (!allPremise || allPremise.length === 0) return null;

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className="ms-3">
      <DropdownToggle
        caret
        tag="button"
        className="btn  d-flex align-items-center justify-content-between"
        style={{
          minWidth: 140,
          padding: "8px 8px",
          borderRadius: 6,
          border: "1px solid #ccc",
          // backgroundColor: "#fff",
          color: "#fff",
          border: "1px solid #333333",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <span
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {allPremise.find((p) => p.id === currentPremise)?.name ||
            "Select Premise"}
        </span>
        <i
          className="bx bx-chevron-down"
          style={{ marginLeft: 10, fontSize: 22, transition: "transform 0.2s" }}
        />
      </DropdownToggle>

      <DropdownMenu
        style={{
          minWidth: 140,
          borderRadius: 10,
          padding: 0,
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
        }}
      >
        {allPremise.map((premise) => (
          <DropdownItem
            key={premise.id}
            onClick={() => handlePremiseChange(premise.id)}
            style={{
              padding: "10px 16px",
              backgroundColor: "#000000",
              color: "#fff",
              cursor: "pointer",
              fontWeight: currentPremise === premise.id ? 600 : 400,
              backgroundColor:
                currentPremise === premise.id ? "#001d3d" : "#003566",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>{premise.name}</span>
            {currentPremise === premise.id && (
              <i
                className="bx bx-check"
                style={{ color: "#0d6efd", fontSize: 18 }}
              />
            )}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default PremiseDropdown;
